import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import ColumnUtils from '@/utils/ColumnUtils'
import { getFilterCacheList, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import {
  cleanCircleObject,
  dateCompare,
  deepCopy,
  ensureExecuteSuccess,
  multiply,
  mergeArray,
  dateCompareYMD
} from '@/utils/commonUtil'
import selectData from '@/utils/selectData'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { Contract } from '@/class/model/mdm/Contract'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import {
  canCreateByCreditInfoDetail,
  checkCreditInfo
} from '@/api/partner/creditInfo'
import { getContractsByCompanyUuids } from '@/api/partner/contract'
import StrUtils from '@/utils/StrUtils'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { cache } from '@/utils/cacheManager'
import { AirPort } from '@/class/model/mdm/AirPort'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { Job } from '@/class/model/booking/Job'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { checkPoNoIsExist } from '@/api/booking/job'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import * as ImportConstant from '@/class/cargo/model/parameters/ImportConstants'
import { sortByMultiField } from '@/utils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment/moment'
import {
  ACTION_ADD,
  CHARGE_SOURCE_SPLIT,
  SALES_CHANNEL_OCR_RECOGNITION
} from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'
import { checkJobProvisionFlag, normalizeProvisionLock } from '@/api/provision/provisionData'

export default {
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      /* ****************************** 初始化 begin ****************************** */
      this.creditOpen = Number(this.context.config.get('creditOpen')) === 1
      this.isSpecifiedSalesBusiness = Number(this.context.config.get('IsSpecifiedSalesBusiness')) === 1
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.branchOfficeCheck = Number(this.context.config.get('departmentSalesOfficeCheck')) === 1
      this.isAddUserDefinedRoles = Number(this.context.config.get('IsAddUserDefinedRoles')) === 1
      this.sopConfigOpen = false
      this.isWithinCloseAccountDate = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.txtSalesOffice = ''
      this.stampPictureView.businessDocuments = []
      this.openProjectConfig = Number(this.context.config.get('openProjectConfig')) === 1
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isProjectLinkedCustomer = Number(this.context.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
      this.loadingPortChanged = false
      // this.isPlatformInsurance = Number(this.context.config.get('isPlatformInsurance')) === 3
      /* ****************************** end ****************************** */
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.job = row
      // 检查计提发布状态
      if (row.uuid) {
        try {
          const res = await checkJobProvisionFlag(row.uuid)
          this.provisionLock = res.ok ? normalizeProvisionLock(res.data) : { etdLocked: false, feeLocked: false }
        } catch (error) {
          console.error('检查计提发布状态失败:', error)
          this.provisionLock = { etdLocked: false, feeLocked: false }
        }
      } else {
        this.provisionLock = { etdLocked: false, feeLocked: false }
      }
      SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
        if (data.sopPushConfig) {
          this.sopConfigOpen = data.sopPushConfig.ifAuto
        }
        this.checkSop()
        this.checkCredit()
      })
      if (row.jobNo) {
        ClosingAccount.isContainClosedCharge(this.context.office.officeId, row.jobNo).then(res => {
          this.isWithinCloseAccountDate = Boolean(res.data)
        })
      }
      if (row.customerId > 0) {
        this.loadCustomerLevel()
        Company.getCompanyById(row.customerId).then(async company => {
          this.contactList = await new Company(company).getContacts()
        })
      }
      const mbl = row.mbl.replace('-', '')
      this.mblCode = mbl.substr(0, 3)
      this.mblNum = mbl.substr(3)
      this.onMblCodeNumBlur(false)
      if (row.salesOffice) {
        this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', row.salesOffice, 'chineseName')
      }
      this.checkValueMatch()
      this.loadWarehouseRegion(false)
      JobUtils.setSailingDay(this.job)
      OverseaCustomerUtils.loadOverseaAgentChanged(this)
      if (!this.isEdit && this.job.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        checkPoNoIsExist(this.job.poNo, this.job.uuid).then(res => { this.poNoRed = (res.data > 0) })
      }
      this.initRegion()
      if (!this.job.uuid) {
        JobUtils.matchUserPortConfig(this, this.job)
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, false, null, null, true)
      } else {
        JobUtils.matchUserPortConfig(this, this.job, false, null, { keepOriginValue: true })
      }
      JobUtils.loadCompanyCargoSales(this.view, this.job, this.isSpecifiedSalesBusiness)
      this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.operateType, this.job.fba)
      this.setSecondaryCustomJobTypeFunc()
      // CARGO-48635 OCR识别 创建业务时，调用委托单位带出逻辑
      if (!this.job.uuid && this.action === ACTION_ADD.code && this.job.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
        const company = await Company.getCompanyById(this.job.customerId)
        if (company) {
          this.txtCustomerId_changeHandler(company)
          this.clearPoNo()
        }
        const carrier = await Company.getCompanyById(this.job.carrierId)
        if (carrier) {
          this.airlineCompanyChange(carrier.cmpIdx)
        }
      }
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },

    async initRegion() {
      if (this.job.loadingPortCode) {
        const port = await AirPort.getAirportByCode(this.job.loadingPortCode)
        if (port && port.region) {
          const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
          const region = regions.find(p => p.code === port.region)
          this.job.regionName = region ? (this.view.isZh ? region.name : region.nameEnglish) : ''
        }
      } else {
        this.job.regionName = ''
      }
    },

    checkSop() {
      this.sopImageA = false
      this.sopImageB = false
      this.sopImageC = false
      const job = this.job
      // 委托单位
      if (job.customerId > 0) {
        this.checkSopByCompany(job.customerId, 1)
      }
      // 指定货代理
      if (job.customerId > 0) {
        this.checkSopByCompany(job.designationAgent, 2)
      }
      // 起运港代理
      if (job.customerId > 0) {
        this.checkSopByCompany(job.loadingAgentId, 3)
      }
    },
    // type代表不同的角色（1委托单位 2指定货代理 3起运港代理）
    checkSopByCompany(companyId, type) {
      if (!this.creditOpen && this.sopConfigOpen) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === companyId)
        const openSop = cmp && cmp.ifOpenSop
        if (type === 1) {
          this.sopImageA = openSop
        } else if (type === 2) {
          this.sopImageB = openSop
        } else if (type === 3) {
          this.sopImageC = openSop
        }
      }
    },
    checkCredit() {
      this.creditTip.showWarningImageA = false
      this.creditTip.showWarningImageB = false
      this.creditTip.showWarningImageC = false
      if (this.creditOpen) {
        const job = this.job
        // 委托单位
        if (job && job.customerId > 0) {
          this.checkCreditByCompany(job.customerId, 1)
        }
        // 指定货代理
        if (job && job.designationAgent > 0) {
          this.checkCreditByCompany(job.designationAgent, 2)
        }
        // 目的港代理
        if (job && job.loadingAgentId > 0) {
          this.checkCreditByCompany(job.loadingAgentId, 3)
        }
      }
    },
    // type代表不同的角色（1委托单位 2指定货代理 3起运港代理）
    checkCreditByCompany(companyId, type) {
      const callback = credit => {
        let checkCredit = false
        const company = this.context.companyList.find(p => p.cmpIdx === companyId)
        if (credit) {
          let tip = ''
          if (credit.amountExceeded || credit.dateExceeded) {
            if (credit.amountExceeded) { tip += this.$t('Partners.limit') }
            if (credit.dateExceeded) { tip += this.$t('Partners.accountPeriod') }
            if (tip !== '') {
              const toolTip = this.$t('Partners.parter') + tip + this.$t('SeaExport.HasExceeded')
              if (type === 1) {
                this.creditTip.showWarningImageA = true
                if (company && company.ifOpenSop && this.sopConfigOpen) {
                  this.sopImageA = true
                }
                this.creditTip.warningImageATip = toolTip
              } else if (type === 2) {
                this.creditTip.showWarningImageB = true
                this.creditTip.warningImageBTip = toolTip
              } else if (type === 3) {
                this.creditTip.showWarningImageC = true
                this.creditTip.warningImageCTip = toolTip
              }
              checkCredit = true
            }
          }
        }
        if (!credit || !checkCredit) {
          if (company && company.ifOpenSop && this.sopConfigOpen) {
            if (type === 1) {
              this.sopImageA = true
              this.showWarningImageA = false
            } else if (type === 2) {
              this.showWarningImageB = false
            } else if (type === 3) {
              this.sopImageC = true
              this.showWarningImageC = false
            }
          }
        }
      }
      checkCreditInfo({ [companyId]: companyId }, CreditInfoUtil.getJobData(this.job)).then(res => {
        for (const item of res.data) {
          callback(item)
        }
      })
    },
    // 加载客户信息
    async loadCustomerLevel(company) {
      this.stampPictureView.businessDocuments = []
      if (!company) {
        company = await Company.getCompanyById(this.job.customerId)
      }
      this.advancePaymentLabel = company && company.ifAdvancePayment ? this.$t('Partners.IfAdvancePayment') : ''
      new Company({ uuid: company.uuid }).getCustomerDetail().then(async customer => {
        if (customer) {
          const customerType = await new Customer(customer).getCustomerType()
          if (customerType) {
            this.customerLevel.level = customerType.typeId
            this.customerLevel.customerName = this.isZh ? customerType.chineseName : customerType.englishName
          }
        }
      })
      // 获取合约状态
      getContractsByCompanyUuids([company.uuid]).then(async res => {
        let contractStatus = 0
        const contracts = res.data
        if (contracts && contracts.length > 0) {
          const now = moment()
          const businessIds = []
          for (const item of contracts) {
            // 过滤出当前合作伙伴所有未到期的合同
            if (dateCompareYMD(item.endDate, now) >= 0) {
              businessIds.push(item.uuid)
            }
          }
          if (businessIds.length > 0) {
            findBusinessDocument({ businessIds: businessIds }).then(res => {
              const docs = res.data
              if (docs && docs.length > 0) {
                const useDocs = []
                for (const doc of docs) {
                  if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                  if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                  useDocs.push(doc)
                }
                this.stampPictureView.businessDocuments = useDocs
              }
            })
          }
          contractStatus = businessIds.length > 0 ? 2 : 1
        }
        const contractState = selectData.contractStatuses[contractStatus]
        this.contractStatusLabel = contractState ? contractState.label : ''
        this.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.job))
      })
    },
    checkValueMatch() {
      let airport = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.loadingPortCode)
      this.valueMatch.loadingPortCode = airport && airport.englishName
      airport = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.dischargingPortCode)
      this.valueMatch.dischargingPortCode = airport && airport.englishName
    },
    // 组装打印参数
    getPrintData() {
      return { JOB_UUID: this.job.uuid, category: 'AIJOBNO', ctx: new AirImportJob(this.job) }
    },
    showSopReceiverDialog(agent, cmpIdx) {
      this.context.loading = true
      SopEmailReceiver.queryJobSopReceiver(this.job.uuid, cmpIdx, agent).then(data => {
        this.sopDialog.cmpIdx = cmpIdx
        this.sopDialog.agent = agent
        this.sopDialog.contactList = data
        this.sopDialog.visible = true
      }).finally(() => {
        this.context.loading = false
      })
    },
    async txtCustomerId_changeHandler(company) {
      this.sopImageA = false
      this.creditTip.showWarningImageA = false
      this.creditTip.warningImageATip = ''
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.cargoSalesList = null
      this.job.customerContact = ''
      this.job.contactTelephone = ''
      this.job.contactFax = ''
      this.stampPictureView.businessDocuments = []
      if (this.job.customerId && parseInt(this.job.customerId) > 0) {
        this.job.preCustomerId = this.job.customerId
      }
      if (!company.cmpIdx) {
        this.job.customerId = 0
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.job.uuid))
      SEUtils.refreshChargeAccountId(this.job, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData, () => {
        this.context.reloadCharge = true
      }) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.job.customerId = company.cmpIdx
      if (this.creditOpen) {
        this.checkCreditByCompany(company.cmpIdx, 1)
        this.checkNewJobCreditInfo()
      } else if (this.sopConfigOpen) {
        this.checkSopByCompany(company.cmpIdx, 1)
      }
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.job.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }

      // 合同限制校验：检查是否启用合同限制且可放号天数<=0
      const contractLimitEnabled = company.contractLimitEnabled
      const availableDays = company.availableReleaseDays

      // contractLimitEnabled 可能是 '1' 或 1
      if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
        // availableReleaseDays 可能是数字或字符串，需要转换
        const daysNum = parseInt(availableDays) || 0
        if (daysNum <= 0) {
          const companyName = company.chineseName || company.englishName || '该委托单位'
          this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
          this.job.customerId = 0
          if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
            this.$refs.customerSelect.clear()
          }
          return
        }
      }

      this.loadCustomerLevel(company)
      if (company.incoTerm) {
        const incoTerm = company.incoTerm.split(',')
        if (incoTerm.length > 0) {
          this.job.incoTerm = incoTerm[0]
        }
      }
      new Company({ uuid: company.uuid }).getContacts().then(contactList => {
        this.contactList = contactList
        const contact = this.getDefaultContact(this.contactList)
        if (contact) {
          this.job.customerContact = contact.contactPerson
          this.job.contactTelephone = contact.telephone
          this.job.contactFax = contact.fax
        }
      })
      await this.loadCompanyUser(company)
      this.loadCustomerSales()
      JobUtils.loadCompanyCargoSales(this.view, this.job, this.isSpecifiedSalesBusiness, true)
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    async loadCompanyUser(company) {
      if (this.isSpecifiedSalesBusiness) {
        const data = await Company.getCompanyUsers(company.uuid)
        await this.loadCompanyUserHandler(data)
      }
    },
    async loadCompanyUserHandler(companyUsers) {
      const job = this.job
      // 销售
      const salesList = []
      let salesDefaultId = 0
      // 客服
      const csrList = []
      let csrDefaultId = 0
      // 单证
      const dcList = []
      let dcDefaultId = 0
      // 揽货销售
      const cargoSalesList = []
      let cargoSalesId = 0
      // 操作
      const opList = []
      let opDefaultId = 0
      // 海外客服
      const overseaOpList = []
      let overseaOpDefaultId = 0
      // 自定义岗位1
      const userDefinedRoleId1List = []
      let userDefinedRoleId1 = 0
      // 自定义岗位2
      const userDefinedRoleId2List = []
      let userDefinedRoleId2 = 0
      // 自定义岗位3
      const userDefinedRoleId3List = []
      let userDefinedRoleId3 = 0
      // 自定义岗位4
      const userDefinedRoleId4List = []
      let userDefinedRoleId4 = 0
      // 自定义岗位5
      const userDefinedRoleId5List = []
      let userDefinedRoleId5 = 0
      // 自定义岗位6
      const userDefinedRoleId6List = []
      let userDefinedRoleId6 = 0
      // 自定义岗位7
      const userDefinedRoleId7List = []
      let userDefinedRoleId7 = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      salesList.push(user)
                    }
                  }
                } else {
                  if (u.defaultUser) {
                    salesDefaultId = u.userId
                  }
                  salesList.push(user)
                }
              } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
                if (u.defaultUser) {
                  csrDefaultId = u.userId
                }
                csrList.push(user)
              } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
                if (u.defaultUser) {
                  dcDefaultId = u.userId
                }
                dcList.push(user)
              } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                if (u.defaultUser) {
                  cargoSalesId = u.userId
                }
                cargoSalesList.push(user)
              } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
                if (u.defaultUser) {
                  opDefaultId = u.userId
                }
                opList.push(user)
              } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                if (u.defaultUser) {
                  overseaOpDefaultId = u.userId
                }
                overseaOpList.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
                if (u.defaultUser) {
                  userDefinedRoleId1 = u.userId
                }
                userDefinedRoleId1List.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
                if (u.defaultUser) {
                  userDefinedRoleId2 = u.userId
                }
                userDefinedRoleId2List.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE3.code) { // 自定义岗位3
                if (u.defaultUser) {
                  userDefinedRoleId3 = u.userId
                }
                userDefinedRoleId3List.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE4.code) { // 自定义岗位4
                if (u.defaultUser) {
                  userDefinedRoleId4 = u.userId
                }
                userDefinedRoleId4List.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE5.code) { // 自定义岗位5
                if (u.defaultUser) {
                  userDefinedRoleId5 = u.userId
                }
                userDefinedRoleId5List.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE6.code) { // 自定义岗位6
                if (u.defaultUser) {
                  userDefinedRoleId6 = u.userId
                }
                userDefinedRoleId6List.push(user)
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE7.code) { // 自定义岗位7
                if (u.defaultUser) {
                  userDefinedRoleId7 = u.userId
                }
                userDefinedRoleId7List.push(user)
              }
            }
          }
        }
      }
      if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        // 销售
        this.salesList = salesList
        this.getTxtSalesPrompt()
        if (salesList.length > 0) {
          if (salesDefaultId > 0) {
            job.sales = salesDefaultId
          } else {
            job.sales = salesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.sales)
            this.salesChangeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.sales = 0
          // job.salesDepartment = 0
          // this.txtSalesOffice = ''
        }
      }
      // 客服
      if (csrList.length > 0) {
        if (csrDefaultId > 0) {
          job.csr = csrDefaultId
        } else {
          job.csr = csrList[0].userId
        }
        this.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.csr)
          this.csrChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.csr = 0
        // job.csrDepartment = 0
      }
      // 单证
      if (dcList.length > 0) {
        if (dcDefaultId > 0) {
          job.dc = dcDefaultId
        } else {
          job.dc = dcList[0].userId
        }
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.dc)
          this.dcChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.dc = 0
        // job.dcDepartment = 0
      }
      // 揽货销售
      if (cargoSalesList.length > 0) {
        if (cargoSalesId > 0) {
          job.cargoSalesId = cargoSalesId
        } else {
          job.cargoSalesId = cargoSalesList[0].userId
        }
        this.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.cargoSalesId)
          this.cargoSalesChargeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.cargoSalesId = 0
        // job.cargoSalesOffice = 0
        // job.cargoSalesDepartment = 0
      }
      if (this.view.isHC) {
        // 操作
        if (opList.length > 0) {
          if (opDefaultId > 0) {
            job.op = opDefaultId
          } else {
            job.op = opList[0].userId
          }

          const user = await User.getUserById(job.op)
          this.view.$nextTick(() => {
            this.opChangeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.op = 0
          // job.opDepartment = 0
        }
        // 海外客服
        if (overseaOpList.length > 0) {
          if (overseaOpDefaultId > 0) {
            job.overseaOp = overseaOpDefaultId
          } else {
            job.overseaOp = overseaOpList[0].userId
          }

          const user = await User.getUserById(job.overseaOp)
          this.view.$nextTick(() => {
            OverseaCustomerUtils.overseaOpChangeHandler(this.view, { ...user, value: user.userId })
          })
        } else {
          // job.overseaOp = 0
          // job.overseaOpDepartment = 0
        }
      }
      // 自定义岗位1
      if (userDefinedRoleId1List.length > 0) {
        job.userDefinedRoleId1 = userDefinedRoleId1 > 0 ? userDefinedRoleId1 : userDefinedRoleId1List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId1)
          this.userDefinedRoleId1Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId1 = 0
        // job.userDefinedRoleDept1 = 0
        // job.userDefinedRoleOffice1 = 0
      }
      // 自定义岗位2
      if (userDefinedRoleId2List.length > 0) {
        job.userDefinedRoleId2 = userDefinedRoleId2 > 0 ? userDefinedRoleId2 : userDefinedRoleId2List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId2)
          this.userDefinedRoleId2Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId2 = 0
        // job.userDefinedRoleDept2 = 0
        // job.userDefinedRoleOffice2 = 0
      }
      // 自定义岗位3
      if (userDefinedRoleId3List.length > 0) {
        job.userDefinedRoleId3 = userDefinedRoleId3 > 0 ? userDefinedRoleId3 : userDefinedRoleId3List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId3)
          this.userDefinedRoleId3Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId3 = 0
        // job.userDefinedRoleDept3 = 0
        // job.userDefinedRoleOffice3 = 0
      }
      // 自定义岗位4
      if (userDefinedRoleId4List.length > 0) {
        job.userDefinedRoleId4 = userDefinedRoleId4 > 0 ? userDefinedRoleId4 : userDefinedRoleId4List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId4)
          this.userDefinedRoleId4Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId4 = 0
        // job.userDefinedRoleDept4 = 0
        // job.userDefinedRoleOffice4 = 0
      }
      // 自定义岗位5
      if (userDefinedRoleId5List.length > 0) {
        job.userDefinedRoleId5 = userDefinedRoleId5 > 0 ? userDefinedRoleId5 : userDefinedRoleId5List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId5)
          this.userDefinedRoleId5Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId5 = 0
        // job.userDefinedRoleDept5 = 0
        // job.userDefinedRoleOffice5 = 0
      }
      // 自定义岗位6
      if (userDefinedRoleId6List.length > 0) {
        job.userDefinedRoleId6 = userDefinedRoleId6 > 0 ? userDefinedRoleId6 : userDefinedRoleId6List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId6)
          this.userDefinedRoleId6Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId6 = 0
        // job.userDefinedRoleDept6 = 0
        // job.userDefinedRoleOffice6 = 0
      }
      // 自定义岗位7
      if (userDefinedRoleId7List.length > 0) {
        job.userDefinedRoleId7 = userDefinedRoleId7 > 0 ? userDefinedRoleId7 : userDefinedRoleId7List[0].userId
        this.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.userDefinedRoleId7)
          this.userDefinedRoleId7Handler({ ...user, value: user.userId })
        })
      } else {
        // job.userDefinedRoleId7 = 0
        // job.userDefinedRoleDept7 = 0
        // job.userDefinedRoleOffice7 = 0
      }
    },
    getTxtSalesPrompt() {
      if (this.isSpecifiedSalesBusiness && (this.$refs.sales.options.length === 0)) {
        this.salesPrompt = this.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
      } else {
        this.salesPrompt = ''
      }
    },
    // 加载客户销售
    async loadCustomerSales() {
      if (!this.isSpecifiedSalesBusiness && String(cache.config.get('ToExoSystem')) !== 'DLWL' && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const company = { ...Company.getCompanyByIdSync(this.job.customerId) }
        const customerDetail = await new Company(company).getCustomerDetail()
        if (customerDetail) {
          if (customerDetail.sales > 0) {
            const salseTemp = customerDetail.sales
            const user = await User.getUserById(salseTemp)
            if (user && user.active) {
              if (this.salesOfficeCheck) {
                this.job.sales = 0
                for (const option of this.$refs.sales.options) {
                  if (option.userId === salseTemp) {
                    this.job.sales = salseTemp
                  }
                }
              } else {
                this.job.sales = salseTemp
              }
              await this.salesChangeHandler(this.job.sales > 0 ? { ...user, value: salseTemp } : { value: 0 })
            }
          } else {
            this.job.sales = 0
            this.job.salesOffice = 0
            this.job.salesDepartment = 0
            this.txtSalesOffice = ''
          }
        }
      }
    },
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    setJobSelectNum(obj) {
      console.log('----------------------->>>>>>>tab', obj)
      this.job[obj.key] = obj.value || 0
    },
    async cargoSource_Change(obj) {
      this.setJobSelectValue(obj)
      const job = this.job
      if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          await this.loadCompanyUser()
          await this.loadCustomerSales()
        }
        await this.checkNewJobCreditInfo()
      } else {
        this.salesList = null
      }
      job.designationAgent = 0
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
      JobUtils.matchUserPortConfig(this, this.job)
    },

    /**
     * 校验新增业务的信控
     * @param job
     * @returns {Promise<void>}
     */
    async checkNewJobCreditInfo() {
      const job = this.job
      if (this.creditOpen && StrUtils.isEmpty(job.uuid)) {
        // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
        const checkResult = this.checkNewJobCreditInfoFunc(job)
        this.processingPromiseList.push(checkResult)
        try {
          await checkResult
        } finally {
          const index = this.processingPromiseList.indexOf(checkResult)
          if (index > -1) {
            this.processingPromiseList.splice(index, 1)
          }
        }
      }
    },
    /**
     * 校验新增业务的信控
     * @param job
     * @returns {Promise<void>}
     */
    async checkNewJobCreditInfoFunc(job) {
      const params = JobUtils.getCreditCheckJob(job)
      await canCreateByCreditInfoDetail(params).then(async res => {
        if (res.data > 0) {
          const msg = {
            dangerouslyUseHTMLString: true,
            message: await JobUtils.checkDateAndAmountExceeded(res.data),
            type: 'warning',
            duration: 5000
          }
          this.$message.warning(msg)
          job.customerId = 0
          this.creditTip.showWarningImageA = false
        }
      })
    },
    async designationAgentChangeHandler(company) {
      this.sopImageB = false
      this.creditTip.showWarningImageB = false
      this.creditTip.warningImageBTip = ''
      if (!company.cmpIdx) {
        this.job.designationAgent = 0
        this.job.sales = 0
        OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
        return
      }
      this.job.designationAgent = company.cmpIdx
      if (this.creditOpen) {
        this.checkCreditByCompany(company.cmpIdx, 2)
      } else if (this.sopConfigOpen) {
        this.checkSopByCompany(company.cmpIdx, 2)
      }
      const overseaAgentDetail = await new Company({ uuid: company.uuid }).getOverseaAgentDetail()
      if (overseaAgentDetail && String(cache.config.get('ToExoSystem')) !== 'DLWL') {
        this.job.sales = 0
        if (this.salesOfficeCheck) {
          for (const option of this.$refs.sales.options) {
            if (option.userId === overseaAgentDetail.owner && option.active) {
              this.job.sales = overseaAgentDetail.owner
              break
            }
          }
        } else {
          this.job.sales = overseaAgentDetail.owner
        }
      }
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    loadingAgentChangeHandler(company) {
      this.sopImageC = false
      this.creditTip.showWarningImageC = false
      this.creditTip.warningImageCTip = ''
      if (!company.cmpIdx) {
        this.job.loadingAgentId = 0
        OverseaCustomerUtils.destinationAgentChangeHandler(this)
        return
      }
      this.job.loadingAgentId = company.cmpIdx
      if (this.creditOpen) {
        this.checkCreditByCompany(company.cmpIdx, 3)
      } else if (this.sopConfigOpen) {
        this.checkSopByCompany(company.cmpIdx, 3)
      }
      OverseaCustomerUtils.destinationAgentChangeHandler(this)
    },
    onMblCodeInput(value) {
      if (value !== this.mblCode) {
        this.mblCode = value
        if (this.mblCode.length === 3) {
          this.$refs.mblNum.$refs.cargoInput.focus()
        }
      }
    },
    onMblCodeNumBlur(blur = true) {
      const codeNum = this.mblCode + this.mblNum
      if (codeNum) {
        if (AirExportUtils.validateMAWBNum(codeNum)) {
          this.mblCodeNumValidate = true
        } else {
          this.mblCodeNumValidate = false
        }
        if (blur) {
          if (!this.job.express) {
            const company = JobUtils.getAirLineCompanyByMblPrefixAndOfficeId(this.mblCode, this.$store.getters.currentOfficeId)
            if (company) {
              this.job.carrierId = company.cmpIdx
            }
          }
          this.fillMBL()
        }
      } else {
        this.mblCodeNumValidate = true
      }
    },
    airlineCompanyChange(value) {
      if (!this.job.express) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', value)
        if (company) {
          const airline = getObjectByCache(basicCacheKeys.basic_data_Airline, 'companyUuid', company.uuid)
          if (airline && airline.mawbprefix) {
            this.mblCode = airline.mawbprefix
          }
        }
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    onMblNumInput(value) {
      if (value !== this.mblNum) {
        this.mblNum = value
        if (!this.mblNum) {
          this.$refs.mblCode.focus()
        }
      }
    },
    fillMBL() {
      const job = this.job
      if (!job.express) {
        if (this.mblCode.length === 3 && !this.mblNum) {
          job.mbl = this.mblCode.replace(/-/g, '')
        } else {
          job.mbl = this.mblCode.replace(/-/g, '')
          if (this.mblNum) {
            job.mbl += this.mblNum
          }
        }
      }
    },
    filterNonDigit(value) {
      return value.replace(/[^\d]/g, '')
    },
    async dischargingPortCode_Change(data) {
      this.valueMatch.dischargingPortCode = true
      this.job.dischargingPortCode = data.value
      this.job.destinationPortCode = data.value
      if (data.value) {
        this.job.destinationPlace = data.englishName
      }
      await this.loadWarehouseRegion(true)
      const mawb = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, true)
      if (mawb) { this.syncJobPortCargoDoc(mawb) }
      const hawb = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.HAWB, true)
      if (hawb) {
        this.syncJobPortCargoDoc(hawb)
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    txtCargoInformationChangeHandler(obj) {
      this.setJobSelectValue(obj)
      this.job.cargoName = obj.englishName || ''
    },
    // etd 修改事件
    async etdChange(value) {
      this.job.etd = value
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
    },
    async etaChange(value) {
      this.job.eta = value
      this.job.businessDate = this.job.eta
      this.job.etaSailingDay = JobUtils.dateChange(this.job.eta)
      await ChargeUtils.updateETDFee(this.job, this.job.eta, this.context, true)
    },
    async atdChange(value) {
      this.job.atd = value
      this.job.atdSailingDay = JobUtils.dateChange(this.job.atd)
    },
    async ataChange(value) {
      this.job.ata = value
      this.job.ataSailingDay = JobUtils.dateChange(this.job.ata)
    },
    async weightContractChange() {
      this.job.weightContract = this.job.weightActual
      await this.refreshWeightCharge(this.job, this.job.weightContract)
      await this.calculateChargeWeight()
      await this.syncHbl('weightContract', 'weight')
    },
    async quantityChange() {
      this.job.quantityContract = this.job.quantityActual
      await this.syncHbl('quantityContract', 'quantity')
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      await ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async cubageContractChange() {
      this.job.cubageContract = this.job.cubageActual
      await this.refreshCubageCharge(this.job, this.job.cubageContract)
      await this.calculateChargeWeight()
      await this.syncHbl('cubageContract', 'cubage')
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    /**
     * 单号抄录
     */
    async onExcerptionChangeFunc(data) {
      this.job.shipperCode = data.shipperCode
      this.job.shipperLine1 = data.shipperLine1
      this.job.consigneeCode = data.consigneeCode
      this.job.consigneeLine1 = data.consigneeLine1
      this.job.notifyCode = data.notifyCode
      this.job.notifyLine1 = data.notifyLine1
      await this.syncHbl('shipperCode')
      await this.syncHbl('shipperLine1')
      await this.syncHbl('consigneeCode')
      await this.syncHbl('consigneeLine1')
      await this.syncHbl('notifyCode')
      await this.syncHbl('notifyLine1')
    },
    async codeSearchCallback(data) {
      if (data.shipperInfo) {
        await this.splitShipperLine(data.shipperInfo)
        if (data.hasOwnProperty('shipperCode')) {
          this.job['shipperCode'] = data.shipperCode || ''
          await this.syncHbl('shipperCode')
        }
      }
      if (data.consigneeInfo) {
        await this.splitConsigneeLine(data.consigneeInfo)
        if (data.hasOwnProperty('consigneeCode')) {
          this.job['consigneeCode'] = data.consigneeCode || ''
          await this.syncHbl('consigneeCode')
        }
      }
      if (data.notifyInfo) {
        await this.splitNotifyLine(data.notifyInfo)
        if (data.hasOwnProperty('notifyCode')) {
          this.job['notifyCode'] = data.notifyCode || ''
          await this.syncHbl('notifyCode')
        }
      }
    },
    mergeShipperLine() {
      let result = ''
      if (this.job['shipperLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['shipperLine' + i] || ''
          result += '\n'
        }
        result += (this.job['shipperLine7'] || '')
      }
      return result.trimEnd()
    },
    async splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }
      await this.syncHbl('shipperLine1')
    },
    mergeConsigneeLine() {
      let result = ''
      if (this.job['consigneeLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['consigneeLine' + i] || ''
          result += '\n'
        }
        result += (this.job['consigneeLine7'] || '')
      }
      return result.trimEnd()
    },
    async splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
      await this.syncHbl('consigneeLine1')
    },
    mergeNotifyLine() {
      let result = ''
      if (this.job['notifyLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['notifyLine' + i] || ''
          result += '\n'
        }
        result += (this.job['notifyLine7'] || '')
      }
      return result.trimEnd()
    },
    async splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
      await this.syncHbl('notifyLine1')
    },
    async shipperAutoCompleteChange(company) {
      const job = this.job
      if (!company.cmpIdx) {
        job.shipperId = 0
        await this.syncHbl('shipperId')
        return
      }
      job.shipperId = company.cmpIdx
      const manifestAddress = await new Company({ uuid: company.uuid }).getManifestAddress()
      if (manifestAddress) {
        job.shipperLine1 = manifestAddress.addressLine1
        job.shipperLine2 = manifestAddress.addressLine2
        job.shipperLine3 = manifestAddress.addressLine3
        job.shipperLine4 = manifestAddress.addressLine4
        job.shipperLine5 = manifestAddress.addressLine5
        job.shipperLine6 = manifestAddress.addressLine6
        job.shipperLine7 = manifestAddress.addressLine7
      } else {
        job.shipperLine1 = ''
        job.shipperLine2 = ''
        job.shipperLine3 = ''
        job.shipperLine4 = ''
        job.shipperLine5 = ''
        job.shipperLine6 = ''
        job.shipperLine7 = ''
      }
      await this.syncHbl('shipperId')
      await this.syncHbl('shipperLine1')
    },
    async consigneeAutoCompleteChange(company) {
      const job = this.job
      if (!company.cmpIdx) {
        job.consigneeId = 0
        await this.syncHbl('consigneeId')
        return
      }
      job.consigneeId = company.cmpIdx
      const manifestAddress = await new Company({ uuid: company.uuid }).getManifestAddress()
      if (manifestAddress) {
        job.consigneeLine1 = manifestAddress.addressLine1
        job.consigneeLine2 = manifestAddress.addressLine2
        job.consigneeLine3 = manifestAddress.addressLine3
        job.consigneeLine4 = manifestAddress.addressLine4
        job.consigneeLine5 = manifestAddress.addressLine5
        job.consigneeLine6 = manifestAddress.addressLine6
        job.consigneeLine7 = manifestAddress.addressLine7
      } else {
        job.consigneeLine1 = ''
        job.consigneeLine2 = ''
        job.consigneeLine3 = ''
        job.consigneeLine4 = ''
        job.consigneeLine5 = ''
        job.consigneeLine6 = ''
        job.consigneeLine7 = ''
      }
      await this.syncHbl('consigneeId')
      await this.syncHbl('consigneeLine1')
      JobUtils.matchUserPortConfig(this, this.job)
    },
    async notifyAutoCompleteChange(company) {
      const job = this.job
      if (!company.cmpIdx) {
        job.notifyId = 0
        await this.syncHbl('notifyId')
        return
      }
      job.notifyId = company.cmpIdx
      const manifestAddress = await new Company({ uuid: company.uuid }).getManifestAddress()
      if (manifestAddress) {
        job.notifyLine1 = manifestAddress.addressLine1
        job.notifyLine2 = manifestAddress.addressLine2
        job.notifyLine3 = manifestAddress.addressLine3
        job.notifyLine4 = manifestAddress.addressLine4
        job.notifyLine5 = manifestAddress.addressLine5
        job.notifyLine6 = manifestAddress.addressLine6
        job.notifyLine7 = manifestAddress.addressLine7
      } else {
        job.notifyLine1 = ''
        job.notifyLine2 = ''
        job.notifyLine3 = ''
        job.notifyLine4 = ''
        job.notifyLine5 = ''
        job.notifyLine6 = ''
        job.notifyLine7 = ''
      }
      await this.syncHbl('notifyId')
      await this.syncHbl('notifyLine1')
    },
    showAdvanceTextDialog(title, value, textChars, successCallback, isUppercase = true) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.textChars = textChars
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    async syncHbl(sourceField, targetFiled) {
      const hbl = await this.getHbl()
      if (hbl) {
        hbl[targetFiled || sourceField] = this.job[sourceField]
      }
    },
    async getHbl() {
      if (this.job.airCargoDoc && this.job.airCargoDoc.length > 0) {
        return this.job.airCargoDoc.find(p => p.docType === CargoDocConsts.HAWB) || null
      }
      // 若为非直单业务，创建一个分单信息保存到业务
      if (this.job.operateType !== ImportConstant.DIRECT.code) {
        const cargoDoc = await new AirCargoDoc().newCargoDoc(this.job, CargoDocConsts.HAWB)
        this.job.airCargoDoc = [cargoDoc]
        return cargoDoc
      }
      return null
    },
    /**
     * 计算计费重量
     * 空运体积和重量的换算是体积（立方米）/0.006=体积重量（公斤）
     * 体积重量大于实际重量时候，计费重量就是体积重量
     * 体积重量小于实际重量的时候，计费重量就是实际重量
     * 0.1《尾数《0.5，则应为进位到0.5
     * 0.5《尾数《1则应进位到1
     */
    async calculateChargeWeight() {
      const job = this.job
      const chargeWeight = job.cubageContract / 0.006
      let value = ''
      if (chargeWeight > job.weightContract) {
        value = ImportConstants.toFixed2(chargeWeight, 1)
      } else {
        value = ImportConstants.toFixed2(job.weightContract, 1)
      }
      job.chargeWeight = Number(value)
      this.syncChargeWeightToCharge()
      await this.syncHbl('chargeWeight', 'cWeight')
    },
    operateType_changeHandler(obj) {
      this.setJobSelectValue(obj)
      this.selectDefaultCutomJobType()
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.operateType, this.job.fba)
    },
    /**
     * 根据操作类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
     */
    async selectDefaultCutomJobType() {
      await ensureExecuteSuccess(() => this.$refs.customJobType && this.$refs.customJobType.options)
      let options = this.$refs.customJobType.options
      const operateType = String(this.job.operateType)
      options = options.filter(p => p.type === this.job.lob && p.containerLoadType === operateType)
      if (options.length > 0) {
        this.job.customJobType = options[0].code
      }
    },
    /**
     * 当选择销售人员的时候自动关联该销售所在分公司
     */
    async salesChangeHandler(data) {
      const job = this.job
      job.sales = data.value || 0
      job.salesOffice = 0
      this.txtSalesOffice = ''
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
          const office = await Office.getOfficeById(job.salesOffice)
          this.txtSalesOffice = office.chineseName
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', job.salesOffice, 'chineseName')
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
              this.txtSalesOffice = office.chineseName
            }
          }
        }
      }
    },
    departmentChangeHandler(department) {
      if (!department.departmentId) {
        this.job.salesDepartment = 0
        return
      }
      this.job.salesDepartment = department.departmentId
      const office = this.context.officeList.find(p => p.uuid === department.officeUuid)
      if (office && office.officeId !== this.job.salesOffice) {
        this.job.salesOffice = office.officeId
        this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', office.officeId, 'chineseName')
      }
    },
    /**
     * 操作改变
     */
    opChangeHandler(user) {
      const job = this.job
      job.op = user.userId || 0
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    /**
     * 客服改变
     */
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    /**
     * 航线改变
     */
    async plannerChangeHandler(data) {
      const job = this.job
      job.planner = data.value || 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'airline', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.plannerOffice = office ? office.officeId : 0
              job.plannerDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'airline')
          job.plannerDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.plannerOffice = office ? office.officeId : 0
        }
      } else {
        job.planner = 0
        job.plannerDepartment = 0
        job.plannerOffice = 0
      }
    },
    endTabHandler() {
      this.fillModel()
    },
    fillModel() {
      const job = this.job
      if (!job.express) {
        this.job.mbl = this.mblCode
        if (this.mblNum) {
          this.job.mbl += this.mblNum
        }
      }
    },
    async getSubmitData() {
      await this.validateForm()
      if (this.job.customerContact) {
        for (const item of this.contactList) {
          if (item.contactPerson === this.job.customerContact) {
            this.job.contactEmail = item.email
          }
        }
      }
      const result = {
        job: this.job
      }
      const hbl = await this.getHbl()
      if (hbl) {
        // 复制时将英文品名和唛头复制到分单信息
        if (this.view.action === 'copy' && !this.job.uuid) {
          hbl.cargoEnglishName = this.job.cargoEnglishName
          hbl.remark1 = this.job.mark
        }
        result.airCargoDoc = [hbl]
      }
      if (this.loadingPortChanged) {
        result.usCustomsClearanceList = this.job.usCustomsClearanceList
      }
      if (this.job.airCargoDoc && this.job.airCargoDoc.length > 0) {
        return { job: this.job, airCargoDoc: this.job.airCargoDoc }
      }
      return result
    },
    async validateForm() {
      const form = this.job
      if (form.customerId < 1) {
        if (form.cargoSource === 'NC') {
          throw new TabError(this.$t('queryJob.ActualNotifierCannotBeBlank'), 'tabBookingFCL')
        } else {
          throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabBookingFCL')
        }
      }
      await JobUtils.checkCustomerBranchScope(form, 'tabBookingFCL')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), form.customerId, 'tabBookingFCL')
      if (form.cargoSource === 'NC') {
        if (form.designationAgent < 1) {
          throw new TabError(this.$t('queryJob.SpecifiedFreightAgentCannotEmpty'), 'tabBookingFCL')
        }
      }
      if (!form.loadingPortCode || !this.valueMatch.loadingPortCode) {
        throw new TabError(this.$t('Message.PortOfLoadingPortCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.dischargingPortCode || !this.valueMatch.dischargingPortCode) {
        throw new TabError(this.$t('Message.PortOfDestinationCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.destinationPlace) {
        throw new TabError(this.$t('Message.PlaceOfDeliveryCannotBeNull'), 'tabBookingFCL')
      }
      // 动态读取UI配置，如果UI配置中ETD为必填，则进行校验
      if (this.elementDict && this.elementDict.etd && this.elementDict.etd.isRequire && !form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.eta) {
        throw new TabError(this.$t('queryJob.ArrivalDateCannotBlank'), 'tabBookingFCL')
      }
      if (form.etd && form.eta && form.eta < form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeLaterThanDateOfArrival'), 'tabBookingFCL')
      }
      if (form.cargoSource === CargoSource.SC_CARGO_SOURCE.code && form.sales === 0) {
        throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBookingFCL')
      }
      if (form.opDepartment === 0) {
        throw new TabError(this.$t('queryJob.OperationDepartmentCannotBlank'), 'tabBookingFCL')
      }
      if (form.sales > 0 && form.salesDepartment <= 0) {
        throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingFCL')
      }
      if (form.loadingAgentId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.PortOfLoadingAgent'), form.loadingAgentId)
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && form.designationAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent)
      }
      if (form.carrierId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.AirlineCompany'), form.carrierId)
      }
      if (form.bookingAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BillExchangeAgent'), form.bookingAgent)
      }
      if (form.customsBroker > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CustomsBroker'), form.customsBroker)
      }
      if (form.customerId > 0) {
        const c = await Company.getCompanyById(form.customerId)
        if (!c || !c.customer || !c.active) {
          throw new TabError(`【${c.chineseName}'】${this.$t('Message.No')}${this.$t('SeaExport.ConsignationCompany')}, ${this.$t('queryJob.PleaseReselect')}.`, 'tabBookingFCL')
        }
        if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
          throw new TabError(this.view.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabBookingFCL')
        }
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingFCL')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingFCL')
      }
    },
    // 投保
    async toInsure() {
      const payload = {
        jobUuid: this.job.uuid,
        branchId: this.view.$store.getters.currentOfficeId,
        billno: this.job.mbl,
        insureType: 'JOB'
      }
      const continueExec = await JobUtils.openInsure(payload, this.view)
      if (continueExec) {
        this.view.$router.push({
          name: 'ToInsurePage',
          query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
          params: { insureForm: payload }
        })
      }
      // if (Number(cache.config.get('isPlatformInsurance')) === 3) {
      //   const payload = {
      //     jobUuid: this.job.uuid,
      //     branchId: this.$store.getters.currentOfficeId,
      //     billno: this.job.mbl,
      //     insureType: 'JOB'
      //   }
      //   const continueExec = await JobUtils.openInsure(payload, this.view)
      //   if (continueExec) {
      //     this.view.$router.push({
      //       name: 'ToInsurePage',
      //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
      //       params: { insureForm: payload }
      //     })
      //   }
      //   return
      // }
      // if (cache.config.get('BurialPointMode') === 'on') {
      //   // LogStores.sendFunctionClickLogStoresByLabel('AI-主票信息' + this.view.$t('SeaExport.Insure'))
      // }
      // if (this.$checkPermission(['button_insurance_toInsure'])) {
      //   const job = deepCopy(this.job)
      //   cleanCircleObject(job)
      //   AirImportJob.toInsure(job, this.context.office).then(data => {
      //     this.insureSuccessHandler(data)
      //   })
      // } else {
      //   this.$message.warning(this.$t('SeaExport.NotInsuranceOperationPermission'))
      // }
    },
    // 投保成功
    // insureSuccessHandler(data) {
    //   const result = data.result
    //   const status = data.status
    //   if (status === 'true') {
    //     window.open(result, '_blank', 'noreferrer')
    //   } else {
    //     this.$message.warning(result)
    //   }
    // },
    async loadWarehouseRegion(updateWarehousing = false) {
      const job = this.job
      if (parseInt(cache.config.get('AssociatedRoute')) !== 1 || !job.dischargingPortCode) return
      const port = await AirPort.getAirportByCode(job.dischargingPortCode)
      if (port) {
        const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
        let region = {}
        if (regions && regions.length > 0) {
          region = regions.find(p => p.code === port.region)
        }
        if (region && region.warehouseRegions && region.warehouseRegions.length > 0) {
          let companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
          if (companyList && companyList.length > 0) {
            companyList = companyList.filter(item => item.warehouse && item.active) || []
          }
          if (region.warehouseRegions.length === 1) {
            const warehouse = companyList.find(p => p.uuid === region.warehouseRegions[0].companyUuid)
            if (warehouse) {
              if (updateWarehousing && job.uuid) {
                await this.warehouseCmpChangeHandler({ value: warehouse.cmpIdx })
              }
            }
          } else {
            if (updateWarehousing) {
              let defaultWarehouseCompany = null
              const warehouseCompanyList = []
              for (const warehouseRegion of region.warehouseRegions) {
                const warehouse = companyList.find(p => p.uuid === warehouseRegion.companyUuid)
                if (warehouse) {
                  if (warehouseCompanyList.findIndex(p => p.uuid === warehouse.uuid) < 0) {
                    warehouseCompanyList.push(warehouse)
                  }
                }
              }
              if (warehouseCompanyList && warehouseCompanyList.length > 0) {
                for (const warehouseCompany of warehouseCompanyList) {
                  await new Company(warehouseCompany).getWarehouseDetail()
                  const defaultWarehouse = Company.defaultWarehouse(warehouseCompany)
                  if (defaultWarehouse) {
                    defaultWarehouseCompany = warehouseCompany
                    break
                  }
                }
                if (!job.warehouseCmp || job.warehouseCmp === 0) {
                  if (defaultWarehouseCompany) {
                    await this.warehouseCmpChangeHandler({ value: defaultWarehouseCompany.cmpIdx })
                  } else {
                    await this.warehouseCmpChangeHandler({ value: 0 })
                  }
                }
              }
            }
          }
        }
      }
    },
    async warehouseCmpChangeHandler(data) {
      const job = this.job
      job.warehouseCmp = data.value || 0
      job.warehouseRecord = job.warehouseCmp
      if (job.warehouseInfo.length === 0) {
        const newData = new WarehouseInfo().fillDefaultValue().getData()
        newData.jobUuid = job.uuid
        job.warehouseInfo.push(newData)
      }
      // 通过此方法加载 warehouseInfo 的联系电话地址等
      await this.getWarehouseInfo()
      const warehouse = job.warehouseInfo[0]
      warehouse.warehouseCmp = job.warehouseCmp
      if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) warehouse.deleted = false
      this.addWarehouseToModifiedSet(warehouse)
    },
    // 添加warehouseInfo到被修改的集合中
    addWarehouseToModifiedSet(warehouse) {
      const modifiedData = this.context.modifiedData
      modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
      if (!modifiedData.warehouseInfo.includes(warehouse)) {
        modifiedData.warehouseInfo.push(warehouse)
      }
    },
    async getWarehouseInfo() {
      const job = this.job
      await new Job(job).getWarehouseInfo()
      if (job.warehouseCmp && job.warehouseCmp > 0) {
        if (!job.warehouseInfo || job.warehouseInfo.length === 0) {
          this.warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
        } else {
          this.warehouseInfo = job.warehouseInfo[0]
        }
        const warehouseInfo = this.warehouseInfo
        if (warehouseInfo && job.warehouseCmp !== warehouseInfo.warehouseCmp) {
          warehouseInfo.warehouseCmp = job.warehouseCmp
          warehouseInfo.jobUuid = job.uuid
          warehouseInfo.contactData = false
          const company = await Company.getCompanyById(job.warehouseCmp)
          if (company) {
            await new Company(company).getWarehouseDetail()
            await this.loadWarehouseDetailHandler(company)
          }
        }
      } else { // 如果手动清空仓储，则打断仓储与Job的关联关系
        if (job.warehouseInfo && job.warehouseInfo.length > 0) {
          for (const warehouseInfo of job.warehouseInfo) {
            warehouseInfo.deleted = true
          }
        }
      }
    },
    async loadWarehouseDetailHandler(company) {
      const warehouseInfo = this.warehouseInfo
      // 仓库地址
      if (company) {
        const warehouseDetail = Company.defaultWarehouse(company)
        if (warehouseDetail) {
          if (warehouseDetail['warehouseAddress']) {
            warehouseInfo.warehouseAddress = warehouseDetail['warehouseAddress']
          } else {
            warehouseInfo.warehouseAddress = company.address
          }
          warehouseInfo.warehouseContact = warehouseDetail['warehouseContact']
          warehouseInfo.warehouseContactTel = warehouseDetail['warehouseContactTel']
          warehouseInfo.warehouseName = warehouseDetail['warehouseName']
          await this.loadContactsFunc(company)
        } else {
          warehouseInfo.warehouseContact = ''
          warehouseInfo.warehouseContactTel = ''
          warehouseInfo.warehouseName = ''
          await this.loadContactsFunc(company)
          warehouseInfo.warehouseAddress = company.address
        }
      }
    },
    async loadContactsFunc(company) {
      const warehouseInfo = this.warehouseInfo
      if (!warehouseInfo.warehouseContact && !warehouseInfo.warehouseContactTel) {
        warehouseInfo.contactData = true
        await new Company(company).getContacts()
        const contacts = company.contacts
        if (contacts && contacts.length > 0) {
          let contact = null
          for (const ct of contacts) {
            if (ct.defaultContact) {
              contact = ct
              break
            }
          }
          if (contact) {
            warehouseInfo.warehouseContact = contact['contactPerson']
            warehouseInfo.warehouseContactTel = contact['telephone']
          } else {
            warehouseInfo.warehouseContact = ''
            warehouseInfo.warehouseContactTel = ''
          }
          warehouseInfo.warehouseName = ''
        }
      }
    },
    // 计费重量变化，是否同步费用
    syncChargeWeightToCharge() {
      let chargeFlag = false
      for (const charge of this.job.charges) {
        if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
            !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
            !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 &&
            ((charge.receivable && this.job.receivableChargeLockedStatus === 0) || (!charge.receivable && this.job.payableChargeLockedStatus === 0))) {
          chargeFlag = true
          break
        }
      }
      if (chargeFlag) {
        this.$confirm(this.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const charges = []
          for (const charge of this.job.charges) {
            if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
                !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
                !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 &&
                ((charge.receivable && this.job.receivableChargeLockedStatus === 0) || (!charge.receivable && this.job.payableChargeLockedStatus === 0))) {
              charge.quantity = this.job.chargeWeight
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
              charges.push(charge)
            }
          }
          if (charges && charges.length > 0) {
            this.context.modifiedData.charges = this.context.modifiedData.charges || []
            mergeArray(this.context.modifiedData.charges, charges)
          }
          this.context.reloadCharge = true
        }).catch(() => {
        })
      }
    },
    // 自定义岗位字段1
    async userDefinedRoleId1Handler(data) {
      const job = this.job
      job.userDefinedRoleId1 = data.value || 0
      job.userDefinedRoleDept1 = 0
      job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept1 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice1 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
          job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice1 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段2
    async userDefinedRoleId2Handler(data) {
      const job = this.job
      job.userDefinedRoleId2 = data.value || 0
      job.userDefinedRoleDept2 = 0
      job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept2 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice2 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
          job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice2 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段3
    async userDefinedRoleId3Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId3 = value || 0
      job.userDefinedRoleDept3 = 0
      job.userDefinedRoleOffice3 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept3 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice3 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
          job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice3 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段4
    async userDefinedRoleId4Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId4 = value || 0
      job.userDefinedRoleDept4 = 0
      job.userDefinedRoleOffice4 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept4 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice4 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
          job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice4 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段5
    async userDefinedRoleId5Handler(data) {
      const job = this.job
      job.userDefinedRoleId5 = data.value || 0
      job.userDefinedRoleDept5 = 0
      job.userDefinedRoleOffice5 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept5 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice5 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
          job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice5 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段6
    async userDefinedRoleId6Handler(data) {
      const job = this.job
      job.userDefinedRoleId6 = data.value || 0
      job.userDefinedRoleDept6 = 0
      job.userDefinedRoleOffice6 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept6 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice6 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
          job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice6 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段7
    async userDefinedRoleId7Handler(data) {
      const job = this.job
      job.userDefinedRoleId7 = data.value || 0
      job.userDefinedRoleDept7 = 0
      job.userDefinedRoleOffice7 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept7 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice7 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
          job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice7 = office ? office.officeId : 0
        }
      }
    },
    // 起运港变更事件
    async loadingPortCodeChange(data) {
      this.loadingPortChanged = false
      this.syncRegion(data)
      if (this.job.usCustomsClearance && this.job.loadingPortCode && data && data.value && data.value !== this.job.loadingPortCode) {
        this.loadingPortChanged = true
        this.job.loadingPortCode = data.value
        if (!this.job.usCustomsClearanceList || this.job.usCustomsClearanceList.length === 0) {
          this.job.usCustomsClearanceList = ''
          await new AirImportJob(this.job).getUsCustomsClearanceList()
        }
        JobUtils.updateUsCustomsClearanceList(this.job)
      } else {
        if (data) {
          this.job.loadingPortCode = data.value || ''
        } else {
          this.job.loadingPortCode = ''
        }
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    async syncJobPortCargoDoc(cargoDoc) {
      const job = this.job
      cargoDoc.podTo = job.dischargingPortCode
      const airportDes = await AirPort.getAirportByCode(job.dischargingPortCode)
      cargoDoc.airportOfDestination = !airportDes ? '' : airportDes.englishName
      // 将修改后的cargoDoc保存回job的airCargoDoc数组中
      if (job.airCargoDoc) {
        const index = job.airCargoDoc.findIndex(doc => doc.docType === cargoDoc.docType)
        if (index >= 0) {
          job.airCargoDoc[index] = cargoDoc
        } else {
          job.airCargoDoc.push(cargoDoc)
        }
      } else {
        job.airCargoDoc = [cargoDoc]
      }
    },
    // CARGO-40263 【航线】取值逻辑：取【装货港】 对应的 【空港】的【区域】字段值 如【装货港】未对应有区域值时，显示为空。
    async syncRegion(data) {
      // 只需要考虑修改的值为空或者不等当前值的情况即可，因为如果一致不会走到这里
      this.job.regionName = ''
      if (data && data.value !== this.job.loadingPortCode) {
        if (data.region) {
          const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
          const region = regions.find(p => p.code === data.region)
          this.job.regionName = region ? (this.view.isZh ? region.name : region.nameEnglish) : ''
        }
      }
    },
    async cargoSalesChargeHandler(data) {
      const job = this.job
      job.cargoSalesId = data.value || 0
      job.cargoSalesDepartment = 0
      job.cargoSalesOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.cargoSalesOffice = office ? office.officeId : 0
              job.cargoSalesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'salesOfGoods')
          if (department) {
            job.cargoSalesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            job.cargoSalesOffice = office ? office.officeId : 0
          }
        }
      }
    },
    async changeProject(p) {
      this.job.poNo = p.value
      this.job.projectName = p.projectName
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.job.poNo).then(res => {
          return res.data
        })
        if (company && this.job.customerId !== company.cmpIdx && company.active) {
          await this.txtCustomerId_changeHandler(company)
        }
      }
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.job.poNo = ''
        this.job.projectName = ''
      }
    },
    executeTask() {
      // 保存客户发运信息
      this.addrPM.job = this.job
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(cache.config.get('syncMailingAddress')) === 1) {
        this.addrPM.saveCheck()
      }
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.job })
    },
    onCustomJobTypeChange(obj) {
      this.setJobSelectValue(obj)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
      this.contractRuleFieldChange(this.job.customerId, this.job.designationAgent)
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.job.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.checkCredit()
      if (this.creditOpen) {
        // this.checkCreditByCompany(customerId, 1)
        // this.checkCreditByCompany(designationAgent, 2)
        this.checkNewJobCreditInfo()
      }
    }
  }
}
